import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import websocketClient from "../../../utils/websocketClient";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SendInterestModal = ({ isOpen, onClose,postId,research_type, postOwnerId }) => {
  console.log("The post id is:",postId,research_type,postOwnerId)
  const [form, setForm] = useState({
    message: "",
    email: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false); 

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!postId)
    {
      toast.error("Post id required to send interest")
      return;
    }
    if(!research_type)
    {
      toast.error("Research type required to send interest")
      return;
    }
    if (!postOwnerId) {
      toast.error("Post owner information is missing. Cannot send interest.");
      return;
    }

    setLoading(true); // 👈 START LOADING

    try {
      const response = await axios.post(
        `${BASE_URL}/marketplace/researcher/interest/`,
        {
          ...form,
          to_user: postOwnerId,
          ...(
            research_type === 'opportunity' ? {opportunity :postId} : {labopportunity:postId}
          ),
        },
        {params:{
          filter_key : research_type === 'opportunity' ? "opportunity" : "labopportunity"
        }
        ,
         headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
      },
        
      );
     
        // const data = await response.json();
            if (response.status === 201) {
               alert("Interest sent successfully!");
                setForm({
    message: "",
    email: "",
    phone: "",
  });
              websocketClient.send(
                JSON.stringify({
                  event: "notifications",
                  type: "NEW_INTEREST_REQUEST",
                  recipientId: postOwnerId,
                  message: "You have a new iterest request",
                  payload: response.data,
                })
              );
                setTimeout(() => {
      // toast.success("Interest sent successfully!");
      onClose();
      setLoading(false);
    }, 3000)

            } else {
              console.error("Error sending request:", response.data);
            }
     
      // console.log("Success:", response);
    

    } catch (error) {
       
      // toast.error(error?.response?.data?.error);
      if(error?.response?.status === 409)
      {
             alert(error?.response?.data?.error)
               onClose();
               setForm({
    message: "",
    email: "",
    phone: "",
  });
      }
      else
      {
              console.error("Error sending interest:", error);
      }
    } finally {
      setLoading(false); // 👈 STOP LOADING
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md relative shadow-lg">

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
          disabled={loading}
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4">Send Interest</h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          <textarea
            name="message"
            placeholder="Why are you interested?"
            value={form.message}
            onChange={handleChange}
            className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="4"
            required
            disabled={loading}
          />

          <input
            type="email"
            name="email"
            placeholder="Your email"
            value={form.email}
            onChange={handleChange}
            className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            disabled={loading}
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone (optional)"
            value={form.phone}
            onChange={handleChange}
            className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={loading}
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0f6abf] text-white py-3 rounded-lg hover:bg-[#0f6abf] transition disabled:opacity-60"
          >
            {loading ? "Sending..." : "Submit Interest"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default SendInterestModal;